// Module
var code = "<template> <require from=\"app/cm/components/household/documents-grid\"></require> <documents-grid household-case-id.bind=\"householdCaseId\" config.bind=\"config\"></documents-grid> </template> ";
// Exports
module.exports = code;